import { useState } from "react"
import { ChevronRight } from "lucide-react"
import { useTranslation } from "@/clientWeb/i18n/LanguageContext"


interface FAQItem {
  question: string
  answer: string
}

// Translation keys under helpFeedback.faqs, resolved at render.
const FAQS: FAQItem[] = [
  { question: "helpFeedback.faqs.startMeetingQ", answer: "helpFeedback.faqs.startMeetingA" },
  { question: "helpFeedback.faqs.participantsQ", answer: "helpFeedback.faqs.participantsA" },
  { question: "helpFeedback.faqs.recordingQ", answer: "helpFeedback.faqs.recordingA" },
  { question: "helpFeedback.faqs.screenShareQ", answer: "helpFeedback.faqs.screenShareA" },
]

export default function HelpFeedback() {
  const t = useTranslation()
  const [activeFaq, setActiveFaq] = useState<number | null>(null)

  return (
    <div className="max-w-6xl mx-auto space-y-4 animate-in fade-in duration-700">

      {/* Header Section */}
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-foreground/80 dark:text-white">
            {t("helpFeedback.title")}
          </h2>
        </div>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          {t("helpFeedback.subtitle")}
        </p>
      </div>

      {/* FAQ Section */}
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          {/* <div className="p-2 bg-primary/10 rounded-lg">
            <HelpCircle className="w-5 h-5 text-primary" />
          </div> */}
          <h3 className="text-md mt-6 font-bold text-slate-900 dark:text-foreground/80 dark:text-white">{t("helpFeedback.faqTitle")}</h3>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, index) => (
            <div
              key={index}
              className={`group border rounded-2xl transition-all duration-200 ${activeFaq === index
                  ? "border-primary/30 bg-primary/5"
                  : "border-stroke-100 dark:border-border dark:border-slate-800 bg-card dark:bg-card"
                }`}
            >
              <button
                onClick={() => setActiveFaq(activeFaq === index ? null : index)}
                aria-expanded={activeFaq === index}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="font-semibold text-sm text-slate-900 dark:text-foreground/80 dark:text-white">
                  {t(faq.question)}
                </span>
                <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${activeFaq === index ? "rotate-90 text-primary" : ""}`} />
              </button>
              {activeFaq === index && (
                <div className="px-5 pb-5 animate-in slide-in-from-top-2 duration-300">
                  <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed border-t border-stroke-100 dark:border-border dark:border-slate-800 pt-4">
                    {t(faq.answer)}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}